export enum BagType {
    PaperBag = 2,
    ReusableBag = 6,
}
